var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#c90f23",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;40",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#c90f23",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;40",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "-0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "-0.5s"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.0ba8c3771a542c620642e3277741772f.svg";
export { ForwardRef as ReactComponent };